import * as React from "react";
import { Callout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

/**
 * RoasWarning component
 */
export const RoasWarning = ({
  isAmazonCustomer,
  roasEnabled,
}: {
  isAmazonCustomer: boolean;
  roasEnabled: boolean;
}): UIElement => {
  const intl = useIntl();
  const warning_text = intl.formatMessage({
    id: "amazon roas: unavailable",
    defaultMessage:
      "The Marketing Efficiency Ratio figure will be inaccurate as we're unable to access your Amazon advertising spend",
  });

  if (isAmazonCustomer && roasEnabled) {
    return <Callout variant="warning" description={warning_text} />;
  }
};
